import React,{useEffect, useState} from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { Button , FooterPages} from '..';

import { useStateContext } from '../../contexts/ContextProvider';
import { RxAvatar } from "react-icons/rx";
import AuthServices from '../../actions/actions';
import { fetchUser } from '../../utils/fetchUser';
import {getVentasSucursal} from "../../services/Documentos";

const UserProfile = () => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const userInfo = fetchUser();
  const navigate = useNavigate();
  const [ventasSucursal, setVentasSucursal] = useState([]);
  // const ventasSucursalDia = useGetVentasSucursalDia();
  const [ventasSucursalDia, setVentasSucursalDia] = useState([]);
  const [ventasMes,setVentasMes] = useState(0);
  const [ventasMesDeb,setVentasMesDeb] = useState(0);
  const [ventasEfectivo,setVentasEfectivo] = useState(0);
  const [ventasFiado,setVentasFiado] = useState(0);
  const [ventasTrans,setVentasTrans] = useState(0);

  const [ventasDia,setVentasDia] = useState(0);
  const [ventasDiaDeb,setVentasDiaDeb] = useState(0);
  const [ventasDiaEfectivo,setVentasDiaEfectivo] = useState(0);
  const [ventasDiaFiado,setVentasDiaFiado] = useState(0);
  const [ventasDiaTrans,setVentasDiaTrans] = useState(0);

  const [ventasVen,setVentasVen] = useState(0);
  const [ventasVenDeb,setVentasVenDeb] = useState(0);
  const [ventasVenEfectivo,setVentasVenEfectivo] = useState(0);
  const [ventasVenFiado,setVentasVenFiado] = useState(0);
  const [ventasVenTrans,setVentasVenTrans] = useState(0);
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Inicio')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  useEffect(()=>{
    //console.log('Entre a useEffect y data tiene ' + JSON.stringify(data));
  /*
    const fetchData = async () => {
      const ventas = await getVentasSucursal(selectedDate.toISOString(),selectedDateEnd.toISOString());
      setVentasSucursal(ventas);
    };
    fetchData();


  const fetchDataDay = async () => {
      const today = new Date();
      //let anno = today.getFullYear();

      // Fecha de inicio del día
      //let startD = anno + '-' + today.getMonth.toString().trim() + '-' + today.getDay.toString().trim() + 'T00:00:00Z';

      const start = new Date(today);
      start.setHours(-4, 1, 0, 0);
      
      // Fecha de finalización del día (23:59:59)
      const end = new Date(today);
      end.setHours(19, 59, 59, 0);

    const ventasDia = await getVentasSucursal(start.toISOString(),end.toISOString());
    setVentasSucursalDia(ventasDia);

  };

  fetchDataDay();
*/
  },[selectedDate,selectedDateEnd]);


  useEffect(() => {
  
    if (ventasSucursal) {
      let totalMes = 0;
      let totalMesDeb = 0;
      let totalMesEfectivo = 0;
      let totalMesFiado = 0;
      let totalMesTrans = 0;
      ventasSucursal.forEach(item => {
           item.ventas.forEach(itemV => {
             if (itemV.total !== undefined) {
             // Totales Mes
               totalMes = totalMes + itemV.total;
             if (itemV.tipoPago.toString().trim() === 'Crédito' ) totalMesDeb = totalMesDeb + itemV.total;
             if (itemV.tipoPago.toString().trim() === 'Débito') totalMesDeb = totalMesDeb + itemV.total;
             if (itemV.tipoPago.toString().trim() === 'Efectivo') totalMesEfectivo = totalMesEfectivo + itemV.total;
             if (itemV.tipoPago.toString().trim() === 'Fiado') totalMesFiado = totalMesFiado + itemV.total;
             if (itemV.tipoPago.toString().trim() === 'Transferencia') totalMesTrans = totalMesTrans + itemV.total;
             }
           });
       });
      setVentasMes(totalMes);
      setVentasMesDeb(totalMesDeb);
      setVentasEfectivo(totalMesEfectivo);
      setVentasFiado(totalMesFiado);
      setVentasTrans(totalMesTrans);
     }

    if (ventasSucursalDia) {
      let totalSuc = 0;
      let totalSucDeb = 0;
      let totalSucEfectivo = 0;
      let totalSucFiado = 0;
      let totalSucTrans = 0;

      let totalVen = 0;
      let totalVenDeb = 0;
      let totalVenEfectivo = 0;
      let totalVenFiado = 0;
      let totalVenTrans = 0;
      ventasSucursalDia.forEach(item => {
        if (item.sucursal !== undefined && item.sucursal === userInfo.sucursalNombre){
           item.ventas.forEach(itemV => {
             if (itemV.total !== undefined) {
                // Totales Dia Sucursal
                  totalSuc = totalSuc + itemV.total;
                if (itemV.tipoPago.toString().trim() === 'Crédito' ) totalSucDeb = totalSucDeb + itemV.total;
                if (itemV.tipoPago.toString().trim() === 'Débito') totalSucDeb = totalSucDeb + itemV.total;
                if (itemV.tipoPago.toString().trim() === 'Efectivo') totalSucEfectivo = totalSucEfectivo + itemV.total;
                if (itemV.tipoPago.toString().trim() === 'Fiado') totalSucFiado = totalSucFiado + itemV.total;
                if (itemV.tipoPago.toString().trim() === 'Transferencia') totalSucTrans = totalSucTrans + itemV.total;

                // Totales Dia Sucursal Vendedor
                if (item.usuario === userInfo.nombre) totalVen = totalVen + itemV.total;
                if (itemV.tipoPago.toString().trim() === 'Crédito' && item.usuario === userInfo.nombre) totalVenDeb = totalVenDeb + itemV.total;
                if (itemV.tipoPago.toString().trim() === 'Débito' && item.usuario === userInfo.nombre) totalVenDeb = totalVenDeb + itemV.total;
                if (itemV.tipoPago.toString().trim() === 'Efectivo' && item.usuario === userInfo.nombre) totalVenEfectivo = totalVenEfectivo + itemV.total;
                if (itemV.tipoPago.toString().trim() === 'Fiado' && item.usuario === userInfo.nombre) totalVenFiado = totalVenFiado + itemV.total;
                if (itemV.tipoPago.toString().trim() === 'Transferencia' && item.usuario === userInfo.nombre) totalVenTrans = totalVenTrans + itemV.total;

              }
           });
        }
       });
      setVentasDia(totalSuc);
      setVentasDiaDeb(totalSucDeb);
      setVentasDiaEfectivo(totalSucEfectivo);
      setVentasDiaFiado(totalSucFiado);
      setVentasDiaTrans(totalSucTrans);

      setVentasVen(totalVen);
      setVentasVenDeb(totalVenDeb);
      setVentasVenEfectivo(totalVenEfectivo);
      setVentasVenFiado(totalVenFiado);
      setVentasVenTrans(totalVenTrans);
     }
 }, [ventasSucursal,ventasSucursalDia]);



 
  return (
    <>
    <div className="nav-item absolute right-1 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96">
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg dark:text-gray-200">Indicadores</p>
        <button
            type="button"
            onClick={ () => { setIsClicked( !isClicked.UserProfile )} }
            style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
            className="text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray"
          >
            <MdOutlineCancel />
          </button>
      </div>
      <div className="flex gap-5 items-center mt-6 border-color border-b-1 pb-6">
       {/*  <img
          className="rounded-full h-24 w-24"
          src={avatar}
          alt="perfil-usuario"
        />
        */}
        <button
          type="button"
          style={{ color: '#03C9D7', backgroundColor: '#E5FAFB'}}
          className=" text-lg rounded-lg p-3 hover:bg-light-gray"
        >
          <RxAvatar />
        </button>
        <div>
          <p className="font-semibold text-sm dark:text-gray-200"> {userInfo.nombre} </p>
          <p className="text-gray-500 text-xs dark:text-gray-400">  {userInfo.rol}  </p>
          <p className="text-gray-500 text-xs font-semibold dark:text-gray-400"> {userInfo.email} </p>
          <p className="text-gray-500 text-xs font-semibold dark:text-gray-400"> {userInfo.sucursalNombre} </p>
          <p className="text-gray-500 text-xs font-semibold dark:text-gray-400"> {userInfo.nombreEmpresa} </p>
        </div>
      </div>
      <div>

      </div>
      <div className="mt-5">
        <Button
          color="white"
          bgColor={currentColor}
          text="Salir"
          borderRadius="10px"
          width="full"
          handleClick={() => {
            setIsClicked( !isClicked.UserProfile );
            AuthServices.logout();
            navigate('/login');
          }}
        />
      </div>
      <FooterPages />
    </div>
      <div className="mt-5">

      </div>
    </>
  );
};

export default UserProfile;